// ----------------------------------------------------------------------

import { ViewSection } from "src/Api/Enum/View";

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_EXTERNAL = {
  termsConditions: 'https://bapdemostorage.blob.core.windows.net/public-docs/CONDIZIONI%20GENERALI%20e%20abbonamento%20BLIMP.pdf'
}

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  sentEmail: path(ROOTS_AUTH, `/sent-email`),
  requestJoin: path(ROOTS_AUTH, `/request-join`),
  passwordChanged: path(ROOTS_AUTH, `/password-changed`),
  tokenExpired: path(ROOTS_AUTH, `/token-expired`),
  registrationComplete: path(ROOTS_AUTH, `/registration-complete`),
  loginSuccess: path(ROOTS_AUTH, `/login-success`),
  loginError: path(ROOTS_AUTH, `/login-error`),
  refreshError: path(ROOTS_AUTH, `/refresh-error`),
  // ── MFA ──────────────────────────────────────────────────────────────
  mfa: path(ROOTS_AUTH, `/mfa`),
  mfaLocked: path(ROOTS_AUTH, `/mfa-locked`),
};

export const isAuthPath = (pathname: string): boolean =>
  pathname === PATH_AUTH.root || pathname.startsWith(`${PATH_AUTH.root}/`);

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page401: '/401',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  manager: `${ROOTS_DASHBOARD}/manage`,
}

export const PATH_WELCOME_PAGE = `${PATH_DASHBOARD.root}/welcomePage`
export const PATH_MAP_LOCATION = `${PATH_DASHBOARD.root}/mapLocation`
export const PATH_MAIN_POM = `${PATH_DASHBOARD.root}/pom`

export const PATH_CUSTOMER_OVERVIEW = `${PATH_DASHBOARD.root}/customerOverview`;

const PATH_MAIN_POM_DETAIL = {
  pom: PATH_MAIN_POM,
  pomView: (id: string) => path(PATH_MAIN_POM, `/${id}`),
  pomEdit: (id: string) => path(PATH_MAIN_POM, `/${id}/edit`)
}

const PATH_VIEW_RETAIL = `${PATH_DASHBOARD.root}/displayView/retail`
export const PATH_VIEW_OOH = `${PATH_DASHBOARD.root}/displayView/ooh`
const PATH_VIEW_CHECK_SENSOR = `${PATH_DASHBOARD.root}/displayView/checkSensor`

export const PATH_VIEW_RETAIL_DETAIL = {
  view: PATH_VIEW_RETAIL,
  viewRetailPerformance: (id: string, pageName?: string) => path(PATH_VIEW_RETAIL, `/${id}/${ViewSection.PERFROMANCE}/${pageName}`),
  viewRetailPom: (id: string) => path(PATH_VIEW_RETAIL, `/${id}/${ViewSection.Pom}`),
  viewRetailMap: (id: string) => path(PATH_VIEW_RETAIL, `/${id}/${ViewSection.MAP}`)
}

export const PATH_VIEW_OOH_DETAIL = {
  view: PATH_VIEW_OOH,
  viewOOHPerformance: (id: string, pageName?: string) => path(PATH_VIEW_OOH, `/${id}/${ViewSection.PERFROMANCE}/${pageName}`),
  viewOOHPom: (id: string) => path(PATH_VIEW_OOH, `/${id}/${ViewSection.Pom}`),
  viewOOHMap: (id: string) => path(PATH_VIEW_OOH, `/${id}/${ViewSection.MAP}`)
}

export const PATH_VIEW_CHECK_SENSOR_DETAIL = {
  root: (sensorId: string) => path(PATH_VIEW_CHECK_SENSOR, `/${sensorId}/${ViewSection.PERFROMANCE}`),
  view: (sensorId: string, pageName: string) => path(PATH_VIEW_CHECK_SENSOR, `/${sensorId}/${ViewSection.PERFROMANCE}/${pageName}`),
}


const PATH_GEO_LOCATION = `${PATH_DASHBOARD.manager}/location`;

export const PATH_LOCATION = {
  location: path(PATH_GEO_LOCATION, `/location`),
  locationView: (id: string) => path(PATH_GEO_LOCATION, `/location/${id}`),
  locationEdit: (id: string) => path(PATH_GEO_LOCATION, `/location/${id}/edit`),
}

export const PATH_CITY = {
  city: path(PATH_GEO_LOCATION, `/city`),
  cityView: (id: string) => path(PATH_GEO_LOCATION, `/city/${id}`),
  cityEdit: (id: string) => path(PATH_GEO_LOCATION, `/city/${id}/edit`),
}

export const PATH_PROVINCE = {
  province: path(PATH_GEO_LOCATION, `/province`),
  provinceView: (id: string) => path(PATH_GEO_LOCATION, `/province/${id}`),
  provinceEdit: (id: string) => path(PATH_GEO_LOCATION, `/province/${id}/edit`),
}

export const PATH_REGION = {
  region: path(PATH_GEO_LOCATION, `/region`),
  regionView: (id: string) => path(PATH_GEO_LOCATION, `/region`),
  regionEdit: (id: string) => path(PATH_GEO_LOCATION, `/region/${id}/edit`),
}

const PATH_SENSOR = `${PATH_DASHBOARD.manager}/sensor`;

export const PATH_Pom = {
  pom: path(PATH_SENSOR, `/pom`),
  pomView: (id: string) => path(PATH_SENSOR, `/pom/${id}`),
  pomEdit: (id: string) => path(PATH_SENSOR, `/pom/${id}/edit`),
}

export const PATH_HEADCOUNTER = {
  headCounter: path(PATH_SENSOR, `/head-counter`),
  headCounterView: (id: string) => path(PATH_SENSOR, `/head-counter/${id}`),
  headCounterEdit: (id: string) => path(PATH_SENSOR, `/head-counter/${id}/edit`),
  headCounterFrames: (id: string) => path(PATH_SENSOR, `/head-counter/${id}/frames`),
}

export const PATH_CAMERA = {
  camera: path(PATH_SENSOR, `/camera`),
  cameraView: (id: string) => path(PATH_SENSOR, `/camera/${id}`),
  cameraEdit: (id: string) => path(PATH_SENSOR, `/camera/${id}/edit`),
}

export const PATH_SOFTWARE_VERSION = {
  softwareVersion: path(PATH_SENSOR, `/softwareVersion`),
  softwareVersionView: (id: string) => path(PATH_SENSOR, `/softwareVersion/${id}`),
  softwareVersionEdit: (id: string) => path(PATH_SENSOR, `/softwareVersion/${id}/edit`),
}

export const PATH_EVENT = {
  event: path(PATH_SENSOR, `/event`),
  eventView: (id: string) => path(PATH_SENSOR, `/event/${id}`),
  eventEdit: (id: string) => path(PATH_SENSOR, `/event/${id}/edit`),
}


export const PATH_CAMPAIGN = `${PATH_DASHBOARD.manager}/view`;

export const PATH_CAMPAIGN_PAGE = {
  view: path(PATH_CAMPAIGN, `/view`),
  viewView: (id: string) => path(PATH_CAMPAIGN, `/view/${id}`),
  viewEdit: (id: string) => path(PATH_CAMPAIGN, `/view/${id}/edit`),
}

const PATH_TAG_CATEGORY = `${PATH_DASHBOARD.manager}/tag-category`;

export const PATH_CATEGORY = {
  category: path(PATH_TAG_CATEGORY, `/category`),
  categoryView: (id: string) => path(PATH_TAG_CATEGORY, `/category/${id}`),
  categoryEdit: (id: string) => path(PATH_TAG_CATEGORY, `/category/${id}/edit`),
}

export const PATH_TAG = {
  tag: path(PATH_TAG_CATEGORY, `/tag`),
  tagView: (id: string) => path(PATH_TAG_CATEGORY, `/tag/${id}`),
  tagEdit: (id: string) => path(PATH_TAG_CATEGORY, `/tag/${id}/edit`),
}

export const PATH_LAYOUT = {
  layout: path(PATH_CAMPAIGN, `/dashboardLayout`),
  layoutView: (id: string) => path(PATH_CAMPAIGN, `/dashboardLayout/${id}`),
  layoutEdit: (id: string) => path(PATH_CAMPAIGN, `/dashboardLayout/${id}/edit`),
}

export const PATH_EXTERNAL_SOURCE = {
  externalSource: path(PATH_DASHBOARD.manager, `/externalSource`),
  externalSourceView: (id: string) => path(PATH_DASHBOARD.manager, `/externalSource/${id}`),
  externalSourceEdit: (id: string) => path(PATH_DASHBOARD.manager, `/externalSource/${id}/edit`),
}

const PATH_BASE_CUSTOMER = `${PATH_DASHBOARD.manager}/customers`;

export const PATH_CUSTOMER = {
  customer: path(PATH_BASE_CUSTOMER, `/customer`),
  customerView: (id: string) => path(PATH_DASHBOARD.manager, `/customer/${id}`),
  customerEdit: (id: string) => path(PATH_DASHBOARD.manager, `/customer/${id}/edit`),
}

export const PATH_INDUSTRY = {
  industry: path(PATH_BASE_CUSTOMER, `/industry`),
  industryView: (id: string) => path(PATH_DASHBOARD.manager, `/industry/${id}`),
  industryEdit: (id: string) => path(PATH_DASHBOARD.manager, `/industry/${id}/edit`),
}

export const PATH_USER = {
  user: path(PATH_BASE_CUSTOMER, `/user`),
  userView: (id: string) => path(PATH_DASHBOARD.manager, `/user/${id}`),
  userEdit: (id: string) => path(PATH_DASHBOARD.manager, `/user/${id}/edit`),
}

export const PATH_GROUP = {
  userGroup: path(PATH_BASE_CUSTOMER, `/usergroup`),
}

export const PATH_TICKETING = {
  ticketing: path(PATH_DASHBOARD.root, `/ticketing`),
  ticketingByPom: (id: string) => path(PATH_DASHBOARD.root, `/ticketing/${id}/sensor`),
  ticketingByLocation: (id: string) => path(PATH_DASHBOARD.root, `/ticketing/${id}/location`),
}

export const PATH_PROFILE = {
  user: path(ROOTS_DASHBOARD, '/profile/user'),
  changePassword: path(ROOTS_DASHBOARD, '/profile/change-password'),
}

export const PATH_PRIVACY = {
  root: '/dashboard/privacy_section',
  legalDocs: '/dashboard/privacy_section/legal-docs',
  qa: '/dashboard/privacy_section/qa',
  contactUs: '/dashboard/privacy_section/contact-us',
};